import { HomeTopBar } from '../feature/main/components/HomeTopBar';
import { Outlet } from 'react-router-dom';
import { useIsLandscape } from '../responsiveDesign/responsiveDesign';

/**
 * Main application layout with TopBar
 * Used for main navigation routes (home, inbox, more)
 *
 * The shared `InboxProvider` is NOT mounted here — it lives in
 * `ProtectedRoutesWrapper`, ABOVE `KeepAliveOutlet`. `MainRouteContainer` is a
 * per-route layout element that `KeepAliveOutlet` caches once per persistent
 * main-nav route (`/` and `/inbox`), so mounting the provider here would create
 * one `useInbox()` core per cached route — double-fetching the inbox first pages
 * and opening a second chat subscription. Both `HomeTopBar` (the badge driver)
 * and the lazily-routed `InboxPage` instead read the single session-scoped core
 * through `useInboxContext()` (finding 1).
 */
export const MainRouteContainer = () => {
  const isLandscape = useIsLandscape();

  return (
    <main>
      {/* Full width on portrait, centered with max-width on landscape */}
      <div
        className={
          isLandscape
            ? "sm:mx-auto sm:max-w-[75%] md:max-w-[75%] lg:max-w-[75%] xl:max-w-[75%] 2xl:max-w-[75%]"
            : "w-full"
        }>
        {/* TopBar - Sticky at top within content area */}
        <div className="sticky top-0 z-50">
          <HomeTopBar />
        </div>

        {/* Padding for top spacing and bottom spacing */}
        <Outlet />
      </div>
    </main>
  );
};
